import {match} from 'ts-pattern';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import type {GetDataByDataQueryApiResponse} from '@dms/api/core';

import {EMPTY_PLACEHOLDER} from 'shared/web';

import type {Card} from '../types/Card';
import {getColumnForState} from './getColumnForState';
import {getUnreadMessageCount} from './getUnreadMessageCount';

export function mapInterestsToCards(interests: GetDataByDataQueryApiResponse): Card[] {
  return interests.rows
    .filter((row) => isNotNilOrEmpty(row.cells))
    .map((row) => ({
      id: row.id,
      column: row.cells.state?.value ? getColumnForState(row.cells.state.value.key) : null,
      title: match(row.cells.vehicle?.value)
        .when(
          (value: string[]) => Array.isArray(value) && value.length > 0,
          (value) => value.join(', ')
        )
        .when(
          (value: string | string[]) => typeof value === 'string',
          (value) => value
        )
        .otherwise(() => EMPTY_PLACEHOLDER),
      subTitle: row.cells.customer?.value?.label || EMPTY_PLACEHOLDER,
      customerId: row.cells.customer?.value?.id ?? null,
      flags:
        row.cells.tag?.value?.map((tag: Record<string, string>) => ({
          label: tag.label,
          colorScheme: tag.color,
        })) || null,
      unreadMessageCount: getUnreadMessageCount(row.cells.unreadMessageCount?.value),
      note: typeof row.cells.note?.value === 'string' ? row.cells.note.value : null,
      price: null,
      date: row.cells.updatedAt?.value || row.cells.createdAt?.value || null,
      lastActivityDate: row.cells.lastActivityDate?.value ?? null,
      lastCommunicationDate: row.cells.lastCommunicationDate?.value ?? null,
      lastCommunicationChannel: row.cells.lastCommunicationChannel?.value?.key ?? null,
      ownerId: row.cells.owner?.value?.id || null,
      origin: 'interest',
    }));
}
